import * as types from './oidcActionTypes';

export default (state = {}, action) => {
    switch (action.type) {
        case types.USER_SIGNED_OUT:
            return Object.assign({}, { signOut: true });
        default:
            return state;
    }
};// JavaScript source code



// WEBPACK FOOTER //
// ./src/oidc/oidcUserActionsReducer.js